import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import { $fontSize, $fontWeightNormal } from '@acko-tech/building-blocks.ui.common'
import { getStringReadTime } from '@utils/readTIme'
import CircleSeparator from '@components/Ackodrive/common/CircleSeparator'
import { AuthorDetailsContainer, AuthorImageContainer, Heading, RootContainer, SubHeading } from './styles'

const AuthorComponent = ({ data, post, contentType }) => {
  const authorPhotoInfo = data?.data?.attributes?.authorPhoto?.data?.attributes || null
  const authorNameInfo = data?.data?.attributes

  const readTime = getStringReadTime(JSON.stringify(post || ''))
  const style = ` #subheading{
    font-size: ${$fontSize.xs};
  color: rgba(0, 0, 0, 0.5);
  font-weight: ${$fontWeightNormal};
  gap: 4px;
  align-items: center;

  @media screen and (max-width: 768px) {
    font-size: ${$fontSize.xxs};
  }
}
  `

  return (
    <RootContainer>
      {authorPhotoInfo?.url && (
        <AuthorImageContainer>
          <Image src={authorPhotoInfo?.url} alt={authorPhotoInfo?.name} layout="fill" />
        </AuthorImageContainer>
      )}
      <AuthorDetailsContainer>
        <Heading href={`/author/${authorNameInfo?.username}`} target="_blank">
          {authorNameInfo?.name}
        </Heading>
        <style dangerouslySetInnerHTML={{ __html: style }} />
        <SubHeading id="subheading">
          <Image src={`${assetLoader()}/images/clock.svg`} alt="ReadTimeIcon" width={16} height={16} />
          <div>{`${readTime} min read`}</div>
          <CircleSeparator />
          <div>{contentType}</div>
        </SubHeading>
      </AuthorDetailsContainer>
    </RootContainer>
  )
}

export default AuthorComponent
